import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import ProfileDefault from '@/assets/img/profile_default.png';
import { CustomAvatar } from './styles';

export function AvatarUser({ size }) {
	return <CustomAvatar size={size || 'large'} icon={<UserOutlined />} src={ProfileDefault} />;
}
